import { render } from "./DashboardGraph.vue?vue&type=template&id=22b132f0"
import script from "./DashboardGraph.vue?vue&type=script&lang=js"
export * from "./DashboardGraph.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__